import supabase from "../stores/supabase";
import supabaseAdmin from "../stores/supabaseAdmin";
import { createClient } from '@supabase/supabase-js'

class AdminService {

  
  async setReportAccess(memberId, accountId, reportTypeId, userName ) {
  
    let { data: credit_info, error } = await supabase.rpc("fninsertreportaccess", { memberid: memberId, accountid: accountId, reporttypeid: reportTypeId, username: userName});
    //alert(JSON.stringify(error));
    if (error !== undefined)
      return null;
    if (credit_info == null)
      return null;

      return credit_info;


  }

    async createInvoice() {
  
    let { data: response, error } = await supabase.rpc("fn_create_invoice");

    if (error !== null){
          alert(JSON.stringify(error));
        return null;
    }
      


      return response;


  }

  async getReportAccess(memberId, report, timeFrame) {

    let today = new Date();
    today.setMonth(today.getMonth()-timeFrame);
    var fromDate = (today.getFullYear() * 10000) + ((today.getMonth()) * 100) + 1;

    if (report == "All")
        return this.getReportAccessAll(memberId, fromDate);
    
    return this.getReportAccessFilter(memberId, report, fromDate);


  }


  async getReportAccessAll(memberId, fromDate) {


    let { data: reportAccess, error } = await supabase
        .from('vw_report_access')
        .select('report_access_id, member_id, user_name , account_id, access_date, is_billable , attribute_description , attribute_value , account_name' )
        .eq('member_id', memberId)
        .gte('access_date_id', fromDate)
        .order('access_date', { ascending: false});
 
    if (error !== null)
    {
        alert("error admin: " + JSON.stringify(error))
      return null;
    }
    if (reportAccess === null)
      return null;

      return reportAccess;

  }

  // return the report based upon a filtered report
  async getReportAccessFilter(memberId, report, fromDate) {

    let { data: reportAccess, error } = await supabase
        .from('vw_report_access')
        .select('report_access_id, member_id, user_name , account_id, access_date, is_billable , attribute_description , attribute_value , account_name' )
        .eq('member_id', memberId)
        .eq('attribute_description', report)
        .gte('access_date_id', fromDate)
        .order('access_date', { ascending: false});
 
    if (error !== null)
    {
        alert("error admin: " + JSON.stringify(error))
      return null;
    }
    if (reportAccess === null)
      return null;

      return reportAccess;
  }

/********************** BEGIN MEMBERS********************* */
  // return all of the members
  async getMembers(memberGroup) {

    if (memberGroup == "All")
      return this.getAllMembers();

    return this.getMemberByGroup(memberGroup);

  }

  async getAllMembers(){

    let { data: members, error } = await supabase
        .from('vw_members')
        .select('member_id, name, contact_first_name, contact_last_name, email, address, city, state, postal_code, phone_number, member_group_id, member_group, file_format_id, file_format' )
        .order('member_id');
 
    if (error !== null)
    {
        alert("error Admin: " + JSON.stringify(error))
      return null;
    }
    if (members === null)
      return null;

      return members;

  }

  async getMemberByGroup(memberGroup){

    let { data: members, error } = await supabase
        .from('vw_members')
        .select('member_id, name, contact_first_name, contact_last_name, email, address, city, state, postal_code, phone_number, member_group_id, member_group, file_format_id, file_format' )
        .eq('member_group', memberGroup)
        .order('member_id');

    if (error !== null)
    {
        alert("error Admin: " + JSON.stringify(error))
      return null;
    }
    if (members === null)
      return null;

      return members;

  }

    async getMemberRoundTable(){

    let { data: members, error } = await supabase
        .from('vw_members')
        .select('member_id, name, contact_first_name, contact_last_name, email, address, city, state, postal_code, phone_number, member_group_id, member_group, file_format_id, file_format' )
        .in('member_group', ['Crossovers', 'West Coast'])
        .order('member_id');

    if (error !== null)
    {
        alert("error Admin: " + JSON.stringify(error))
      return null;
    }
    if (members === null)
      return null;

      return members;

  }

  async getMemberbyId(memberId){

    let { data: members, error } = await supabase
        .from('vw_members')
        .select('member_id, name, contact_first_name, contact_last_name, email, address, city, state, postal_code, phone_number, member_group_id, member_group, file_format_id, file_format' )
        .eq('member_id', memberId);
 
    if (error !== null)
    {
        alert("error Admin: " + JSON.stringify(error))
      return null;
    }
    if (members === null)
      return null;

      return members;

  }

  async addMember(memberData){
    //alert(JSON.stringify(memberData));

    let { data, error } = await supabase
    .from('member')
    .insert([
        { member_id: memberData.memberId, name: memberData.name, contact_first_name: memberData.contactFirstName, contact_last_name: memberData.contactLastName, email: memberData.email, address: memberData.address, city: memberData.city, state: memberData.state, postal_code: memberData.zip, phone_number: memberData.phoneNumber, member_group_id: memberData.memberGroupId, file_format_id: memberData.fileFormatId },
    ])
 
    if (error !== null)
    {
      alert(JSON.stringify(error));
      return null;
    }
    if (data === null)
      return null;

    return null;
  }

  async updateMember(memberData){
    //alert(JSON.stringify(memberData));

    let { data, error } = await supabase
    .from('member')
    .update([
        { name: memberData.name, contact_first_name: memberData.contactFirstName, contact_last_name: memberData.contactLastName, email: memberData.email, address: memberData.address, city: memberData.city, state: memberData.state, postal_code: memberData.zip, phone_number: memberData.phoneNumber, member_group_id: memberData.memberGroupId, file_format_id: memberData.fileFormatId },
    ])
    .eq('member_id', memberData.memberId)
 
    if (error !== null)
    {
      alert(JSON.stringify(error));
      return null;
    }
    if (data === null)
      return null;

    return null;
  }

  async DeleteMember(member_id){
    //alert(JSON.stringify(memberData));

    let { data, error } = await supabase
    .from('member')
    .update([
        { is_deleted: 1 },
    ]).eq('member_id',member_id)
 
    if (error !== null)
    {
      alert(JSON.stringify(error));
      return null;
    }
    if (data === null)
      return null;

    return null;
  }

  /********************** END MEMBERS********************* */

  /*********************BEGIN USERS************************* */

  async getAllUsers(){

    let { data: users, error } = await supabase
        .from('user_info')
        .select('user_info_id, email, user_name, member_id, member(name), profile' );
 
    if (error !== null)
    {
        alert("error Admin: " + JSON.stringify(error))
      return null;
    }
    if (users === null)
      return null;

      return users;

  }

  async getUserById(userInfoId){

    let { data: users, error } = await supabase
        .from('user_info')
        .select('user_info_id, internal_id, email, user_name, member_id, member(name), profile' )
        .eq('user_info_id', userInfoId);
 
    if (error !== null)
    {
        alert("error Admin: " + JSON.stringify(error))
      return null;
    }
    if (users === null)
      return null;

      return users;

  }

  async addUser(userInfo){

    let { data: authuser, error: authError} =  await supabaseAdmin.auth.admin.createUser({
      email: userInfo.email,
      password: userInfo.password,
      email_confirm: true
    })

    if (authError == null)
      {

        let { data: users, error } = await supabase
            .from('user_info')
            .insert([{user_name: userInfo.userName, email: userInfo.email, member_id: userInfo.memberId, profile: userInfo.profile, internal_id: authuser.user.id}])
    
            //alert(JSON.stringify(users))
        if (error !== null)
        {
            alert("error user: " + JSON.stringify(error))
          return null;
        }
      }
      else {
        alert("error saving user: " + JSON.stringify(authError))
      }


      return null;

  }

  async updateUser(userInfo){


    let { data: authuser, error: authError} =  await supabaseAdmin.auth.admin.updateUserById( userInfo.internalId, {
      email: userInfo.email
    })

    if (authError !== null)
      {
          alert("error Updating email: " + JSON.stringify(authError))
        return null;
      }

    let { data: users, error } = await supabase
            .from('user_info')
            .update([{user_name: userInfo.userName, email: userInfo.email, member_id: userInfo.memberId, profile: userInfo.profile}])
            .eq('user_info_id', userInfo.userInfoId)

    
            //alert(JSON.stringify(users))
        if (error !== null)
        {
            alert("error user: " + JSON.stringify(error))
          return null;
        }

    if (userInfo.UpdatePassword == "checked")
    {
      await this.updateUserPassword(userInfo)
    }
    
        return null;

  }

  async updateUserPassword(userInfo){

  
    let { data: authuser, error: authError} =  await supabaseAdmin.auth.admin.updateUserById( userInfo.internalId, {
      password: userInfo.password
    })

    if (authError === null)
      alert(userInfo.userName + "'s password successfully updated!")
    if (authError !== null)
      {
          alert("error Updating Password: " + JSON.stringify(authError))
        return null;
      }

      return null;

  }



  /**********************END USERS **************************** */
  /*******************BEGIN MANAGE COMPANIES ******************** */

  async addCCIAccount(phoneNumber ) {
  
    let { data, error } = await supabase
    .from('cci_account')
    .insert([
        { phone: phoneNumber, account_type_id: 50 },
    ]).select()
 
    if (error !== null)
      return null;
    if (data === null)
      return null;

    return data

  }

  async updateAccountNewCCIAccount (accountId, cciAccountId)
  {

    let {data, error} = await supabase
    .from('account')
    .update({cci_account_id: cciAccountId, is_primary: 1})
    .eq('account_id', accountId)

    if (error !== null)
      {
        alert("Error: " + JSON.stringify(error))
        return null;
      }

    return 1
  }

  async updateParentAccount (accountId, cciAccountId)
  {

    let {data, error} = await supabase
    .from('account')
    .update({cci_account_id: cciAccountId, is_primary: 0})
    .eq('account_id', accountId)

    if (error !== null)
      {
        alert("Error: " + JSON.stringify(error))
        return null;
      }

    return 1
  }

  async deleteAccount( accountId ) {
  
    let { data: account_info, error } = await supabase.rpc("fndeleteaccount", { accountid: accountId});
    //alert(JSON.stringify(error));
    if (error !== undefined)
      return null;
    if (account_info == null)
      return null;

      return account_info;


  }

  /*******************END MANAGE COMPANIES ************************* */
  /*******************BEGIN INVOICES ******************************* */

  async getInvoices() {

     let { data: invoices, error } = await supabase
        .from('invoice')
        .select('invoice_id, member_id, invoice_month, created_date, date_paid, amount_due' )
        .order ('invoice_id', {ascending: false});
 
    if (error !== null)
    {
        alert("error Admin: " + JSON.stringify(error))
      return null;
    }
    if (invoices === null)
      return null;

      return invoices;

  }

  async getInvoiceDetails(invoiceId, report_type) {

     let { data: invoices, error } = await supabase
        .from('vw_report_access')
        .select('report_access_id, member_id, user_name, account_id, access_date, is_billable, attribute_value, attribute_description, account_name, address1, city, state, zip' )
        .eq('invoice_id', invoiceId)
        .eq('attribute_description', report_type)
        .order ('access_date', {ascending: false});
 
    if (error !== null)
    {
        alert("error Admin: " + JSON.stringify(error))
      return null;
    }
    if (invoices === null)
      return null;

      return invoices;

    }

  async payInvoice(invoiceId){
    //alert(JSON.stringify(memberData));

    let { data, error } = await supabase
    .from('invoice')
    .update([
        { date_paid:  new Date().toISOString()},
    ])
    .eq('invoice_id', invoiceId)
 
    if (error !== null)
    {
      alert(JSON.stringify(error));
      return null;
    }
    if (data === null)
      return null;

    return null;
  }

}


export default new AdminService()